import React from 'react';
import { DIRECT_PAYMENT, TRACKED_PAYMENT } from '../../../constant/constant';

const DeliveryModePicker = ({ value, onChange }) => {
    const isDirect = value === DIRECT_PAYMENT;
    const isTracked = value === TRACKED_PAYMENT;

    const optionClass = (selected) =>
        `group relative flex flex-1 flex-col rounded-xl border px-4 py-3.5 text-left transition-all ${
            selected
                ? 'border-teal-300 bg-teal-50 ring-1 ring-teal-200 dark:border-emerald-500/30 dark:bg-emerald-500/[0.08] dark:ring-emerald-500/20'
                : 'border-zinc-200 bg-zinc-50/80 hover:border-zinc-300 dark:border-zinc-700 dark:bg-zinc-900/40 dark:hover:border-zinc-600'
        }`;

    const iconClass = (selected) =>
        `mb-2.5 flex h-9 w-9 items-center justify-center rounded-lg transition-colors ${
            selected
                ? 'bg-teal-100 text-teal-800 dark:bg-emerald-500/15 dark:text-emerald-400'
                : 'bg-zinc-100 text-zinc-500 group-hover:text-zinc-700 dark:bg-zinc-800 dark:group-hover:text-zinc-300'
        }`;

    return (
        <div className="space-y-3">
            <p className="text-xs text-zinc-600 dark:text-zinc-400">
                Choose how funds should reach the receiver. You can switch anytime
                before confirming.
            </p>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <button
                    type="button"
                    onClick={() => onChange(DIRECT_PAYMENT)}
                    className={optionClass(isDirect)}
                >
                    <span className={iconClass(isDirect)}>
                        <i className="fa-solid fa-arrow-up-long text-sm" />
                    </span>
                    <span
                        className={`text-sm font-semibold ${
                            isDirect
                                ? 'text-zinc-900 dark:text-white'
                                : 'text-zinc-700 dark:text-zinc-300'
                        }`}
                    >
                        Direct payment
                    </span>
                    <span className="mt-1 text-[11px] leading-relaxed text-zinc-600 dark:text-zinc-500">
                        Instant transfer — no lock-up or milestones.
                    </span>
                    <span
                        className={`mt-2 inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider ${
                            isDirect
                                ? 'text-teal-800 dark:text-emerald-300'
                                : 'text-zinc-500'
                        }`}
                    >
                        <i className="fa-solid fa-bolt text-[9px]" />
                        Instant
                    </span>
                </button>

                <button
                    type="button"
                    onClick={() => onChange(TRACKED_PAYMENT)}
                    className={optionClass(isTracked)}
                >
                    <span className={iconClass(isTracked)}>
                        <i className="fa-regular fa-clock text-sm" />
                    </span>
                    <span
                        className={`text-sm font-semibold ${
                            isTracked
                                ? 'text-zinc-900 dark:text-white'
                                : 'text-zinc-700 dark:text-zinc-300'
                        }`}
                    >
                        Tracked payment
                    </span>
                    <span className="mt-1 text-[11px] leading-relaxed text-zinc-600 dark:text-zinc-500">
                        Escrow with milestone releases and dispute support.
                    </span>
                    <span
                        className={`mt-2 inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider ${
                            isTracked
                                ? 'text-teal-800 dark:text-emerald-300'
                                : 'text-zinc-500'
                        }`}
                    >
                        <i className="fa-solid fa-shield-halved text-[9px]" />
                        Escrow
                    </span>
                </button>
            </div>
        </div>
    );
};

export default DeliveryModePicker;
